module.exports = __webpack_public_path__ + "img/10.879c625d.jpg";